import { I18nProvider, useI18n } from '@platform/i18n';
import { Button } from '@platform/ui';
import { useEffect, useState, type ReactNode } from 'react';

function Offline() {
  const { t } = useI18n();
  return <main className="flex min-h-dvh flex-col items-center justify-center gap-4 p-4"><h1 className="text-xl font-semibold">{t('webmail.pwa.offlineTitle')}</h1><p>{t('webmail.pwa.offlineBody')}</p><Button onClick={() => window.location.reload()}>{t('webmail.pwa.retry')}</Button></main>;
}
/** Unmount private views offline. Reconnection remounts auth and performs fresh server admission. */
export function ConnectivityBoundary({ children }: { children: ReactNode }) {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const offline = () => setOnline(false), online = () => setOnline(true);
    window.addEventListener('offline', offline); window.addEventListener('online', online);
    return () => { window.removeEventListener('offline', offline); window.removeEventListener('online', online); };
  }, []);
  return online ? children : <I18nProvider><Offline /></I18nProvider>;
}
